import heroBgField from '../fields/heroBgField';
import ctaField from '../fields/ctaField';

export default {
  value: 'hero',
  label: 'Hero',
  fields: [
    {
      label: 'Title',
      name: 'title'
    },
    {
      label: 'Subtitle',
      name: 'subtitle',
      size: 'small'
    },
    {
      label: 'Content',
      name: 'content',
      type: 'richText'
    },
    heroBgField,
    ctaField
  ]
};
